import { Injectable } from '@angular/core';
import { ApiRoutes } from "../../../services/apiroutes";
import { HttpClient } from "@angular/common/http";
import { ILeaseQuoteModel, LeaseQuoteModel } from "./lease_quote.model";
import { map } from "rxjs/operators";
import { AuthService } from "../../../services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class LeaseRequestService {

  leaseQuote: LeaseQuoteModel;

  constructor(private http: HttpClient, private auth: AuthService) {
  }

  newLeaseQuote(lead: string) {
    this.leaseQuote = new LeaseQuoteModel(lead);

    let user = this.auth.getUserProfile();
  }

  saveLeaseQuote(requirementId) {
    const url = `${ApiRoutes.LeadRequest}request_quotes/${requirementId}/lease/`;

    return this.http.post<ILeaseQuoteModel>(url, this.leaseQuote.getSavePayload()).pipe(
      map((data: ILeaseQuoteModel) => {
        this.leaseQuote.savePayloadToModel(data);
      })
    );
  }
}
